var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8 1.5C3.42518 1.5 1.5 3.42518 1.5 5.8C1.5 8.17482 3.42518 10.1 5.8 10.1C8.17482 10.1 10.1 8.17482 10.1 5.8C10.1 3.42518 8.17482 1.5 5.8 1.5ZM0.5 5.8C0.5 2.87289 2.87289 0.5 5.8 0.5C8.72711 0.5 11.1 2.87289 11.1 5.8C11.1 8.72711 8.72711 11.1 5.8 11.1C2.87289 11.1 0.5 8.72711 0.5 5.8Z",
    fill: "#1D1D46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69022 3.12075C5.04206 2.97501 5.41917 2.9 5.8 2.9C6.07614 2.9 6.3 3.12386 6.3 3.4C6.3 3.67614 6.07614 3.9 5.8 3.9C5.55049 3.9 5.30342 3.94914 5.0729 4.04463C4.84238 4.14011 4.63293 4.28007 4.4565 4.4565C4.28007 4.63293 4.14011 4.84238 4.04463 5.0729C3.94914 5.30342 3.9 5.55049 3.9 5.8C3.9 6.07614 3.67614 6.3 3.4 6.3C3.12386 6.3 2.9 6.07614 2.9 5.8C2.9 5.41917 2.97501 5.04206 3.12075 4.69022C3.26649 4.33837 3.4801 4.01868 3.74939 3.74939C4.01868 3.4801 4.33837 3.26649 4.69022 3.12075Z",
    fill: "#1D1D46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2464 10.2464C10.4417 10.0512 10.7583 10.0512 10.9536 10.2464L13.3536 12.6464C13.5488 12.8417 13.5488 13.1583 13.3536 13.3536C13.1583 13.5488 12.8417 13.5488 12.6464 13.3536L10.2464 10.9536C10.0512 10.7583 10.0512 10.4417 10.2464 10.2464Z",
    fill: "#1D1D46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a1c7e7d8c8884d3d5cef11a1ec4fc5ea.svg";
export { ForwardRef as ReactComponent };